<template>
    <div id="map"></div>
</template>
<script>
import 'maplibre-gl/dist/maplibre-gl.css';
//import maplibregl from 'maplibre-gl';
import { Map, NavigationControl, Marker, LngLatBounds, Popup } from 'maplibre-gl';
export default { 
  name: 'MapLibre',
  data() {
    return {
        map : {},
        maploaded : false,
        geojson: {
            "type": "FeatureCollection",
            "features": []
        },
        mapConfig_clusters : {
            id: 'clusters',
            type: 'circle',
            source: 'offres',
            filter: ['has', 'point_count'],
            paint: {
            'circle-color': [
                'step',
                ['get', 'point_count'],
                '#75C6C3',
                10,
                '#75C6C3',
                70,
                '#75C6C3'
            ],
            'circle-radius': [
                'step',
                ['get', 'point_count'],
                20,
                100,
                30,
                750,
                40
            ]
            }
        },
        mapConfig_cluster_count : {
            id: 'cluster-count',
            type: 'symbol',
            source: 'offres',
            filter: ['has', 'point_count'],
            layout: {
            'text-field': '{point_count_abbreviated}',
            'text-size': 11
            }
        },
        mapConfig_cluster_unclustered : { 
            id: 'unclustered-point',
            type: 'circle',
            source: 'offres',
            filter: ['!', ['has', 'point_count']],
            paint: {
            'circle-color': '#ffffff',
            'circle-radius': 6,
            'circle-stroke-width': 6,
            'circle-stroke-color': '#75C6C3'
            }
        },
        userMarker : false,
    }
  },
  props: ["offres", "geoloc"],
  mounted() {
    this.geojson.features = this.createGeojson(this.offres);
    import('maplibre-gl').then(() => {
        this.createMap();
    });
    
  },
  methods : {
    fitMapToMarkers(map, features) {
        if(map && features.length > 0) {
            const bounds = new LngLatBounds();
            features.forEach(({ geometry }) => bounds.extend(geometry.coordinates));
            map.fitBounds(bounds, { padding: 100, maxZoom: 9 });
        }
    },
    createGeojson(offres) {
        
        return offres.map((offre) => ({
            type: 'Feature',
            properties: {
                title: offre.post_title,
                link: offre.permalink,
                thumbnail: offre.thumbnail,
                type: 'Pin'
            },
            geometry: {
                type: 'Point',
                coordinates: [offre.acf.GmapLongitude, offre.acf.GmapLatitude]
            }
        }));
    },
    async createMap() {
        this.map = new Map({
            container: 'map', 
            style: this.$parent.comtourismeapi.mapbox_style, 
            center: this.$parent.comtourismeapi.mapbox_center,
            zoom: 9,
        });
        this.map.addControl(new NavigationControl());
        this.map.on('load', () => {
            this.map.addSource('offres', { 
                type: 'geojson',
                data: this.geojson,
                cluster: true,
                clusterMaxZoom: 14,
                clusterRadius: 50
            });
            this.map.addLayer(this.mapConfig_clusters);
            this.map.addLayer(this.mapConfig_cluster_count);
            this.map.addLayer(this.mapConfig_cluster_unclustered);

            this.map.on('click', 'clusters', (e) => {
                const features = this.map.queryRenderedFeatures(e.point, {
                    layers: ['clusters']
                });
                const clusterId = features[0].properties.cluster_id;
                this.map.getSource('offres').getClusterExpansionZoom(
                    clusterId,
                    (err, zoom) => {
                    if (err) return;

                    this.map.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom: zoom
                    });
                    }
                );
            });

            this.map.on('mouseenter', 'clusters', () => {
                this.map.getCanvas().style.cursor = 'pointer';
            });
            this.map.on('mouseleave', 'clusters', () => {
                this.map.getCanvas().style.cursor = '';
            });
            this.map.on('click', 'unclustered-point', (e) => {
                const coordinates = e.features[0].geometry.coordinates.slice();
                const title = e.features[0].properties.title;
                let thumbnail = null;
                let permalink = null;

                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
                
                if(e.features[0].properties.thumbnail) {
                    thumbnail = '<img alt="'+e.features[0].properties.title+'" src="'+e.features[0].properties.thumbnail+'" class="img-fluid" />';
                }
                else {
                    thumbnail = '<span class="no-thumbnail"></span>';
                }

                if(e.features[0].properties.link) {
                    permalink = '<a href="'+e.features[0].properties.link+'" title="'+e.features[0].properties.title+'">'+thumbnail+' <span class="titre">'+title+'</span></a>';
                }

                new Popup()
                .setLngLat(coordinates)
                .setHTML(
                `${permalink}`
                )
                .addTo(this.map);
            })
            this.maploaded = true;
        });
    }
  },
  watch: {
    offres: {
      handler() {
        this.geojson.features = this.createGeojson(this.offres);
        if(this.maploaded) {
            this.map.getSource('offres').setData(this.geojson);
            this.fitMapToMarkers(this.map, this.geojson.features);
        } 
      },
      deep:true
    },
    geoloc: {
        handler() {
            if(this.geoloc !== false) {
                const el = document.createElement('div');
                el.className = 'Usermarker';
                this.userMarker = new Marker({element: el}).setLngLat(this.geoloc);
                this.userMarker.addTo(this.map);
            }
            else {
                this.userMarker.remove();
            }
        },
        deep:true
    }
  }
}
</script>
<style>
#map {width:100%; height:400px;}
</style>